// extracted by mini-css-extract-plugin
module.exports = {"link":"_360Mh","GamingButton":"_3qyC3","gamingButton":"_3qyC3","label":"_1E-Ga","left":"_1n9jd","right":"_3nUa1","gradient":"_36sv9"};